















import { Vue, Component, Prop } from "vue-property-decorator";
import { auth } from '../auth/AuthService';
import router from '../router';

@Component
export default class SignedOut extends Vue {
  login() {
    router.replace('/');
    auth.login();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SignedOut.vue